define(function(require, exports, module) {

    'use strict';

    // @ngInject
    exports.metAmountCurrency = function(lpCoreI18n) {

        var CLASS_AMOUNT_NEGATIVE = 'lp-amount-negative';
        var CLASS_AMOUNT_POSITIVE = 'lp-amount-positive';

        function templateFn() {
            return '<span class="{{signClass}}">{{formattedAmount}}</span>';
        }

        function linkFn(scope, element, attrs) {
            function formatAmount() {
                var amount = parseFloat(scope.amount);
                scope.signClass = amount < 0 ? CLASS_AMOUNT_NEGATIVE : CLASS_AMOUNT_POSITIVE;
                scope.currency = scope.currency ? scope.currency.trim() : '';
                scope.formattedAmount = lpCoreI18n.formatCurrency(amount, scope.currency);
                const re = /^\d*(\.\d+)?$/;
                if(scope.formattedAmount.match(re)){
                    scope.formattedAmount =scope.currency + lpCoreI18n.formatCurrency(amount, scope.currency) ;
                }
            }
            scope.$watch('amount', formatAmount);
            scope.$watch('currency', formatAmount);

            scope.$on('$localeChangeSuccess', formatAmount);
        }

        return {
            restrict: 'E',
            template: templateFn,
            link: linkFn,
            scope: {
                'amount': '=mount',
                'currency': '=mountCurrency'
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/metAmountCurrency.js